import { object, ref, setLocale, string } from 'yup'

setLocale({
  mixed: {
    default: 'common.required',
    required: 'common.required',
    notType: 'common.required'
  }
})

export default object().shape({
  address: object().nullable().shape({
    address_number: string().notRequired(),
    address: string().notRequired(),
    city_id: string().required(),
    country_id: string().required(),
    description: string().notRequired(),
    state_id: string().required()
  }),
  birthdate: string().required(),
  confirm_password: string().when(['change_password', 'user_id'], {
    is: (change_password, user_id) => change_password || !user_id,
    then: string()
      .required()
      .oneOf(
        [ref('password')],
        'web.side.user.change-password.retype-password.not-same'
      )
  }),
  first_name: string().required(),
  gender: string().required(),
  last_name: string().required(),
  login_splited: string().required(),
  login_sufix: string().required(),
  password: string().when(['change_password', 'user_id'], {
    is: (change_password, user_id) => change_password || !user_id,
    then: string()
      .matches(/^[^\s]+$/, {
        message: 'web.side.user.change-password.password.invalid-character'
      })
      .min(6, 'web.side.user.change-password.password.min-length')
      .required(),
    otherwise: string().min(60, 'common.required')
  }),
  preferred_language: string().required(),
  vat_number: string().required()
})
